/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type Params = any;

export const handleKeyPress = (
    event: React.KeyboardEvent<HTMLElement>,
    keys: string[],
    func: (...args: Params[]) => void,
    ...params: Params
) => {
    event.preventDefault();
    if (keys.includes(event.key)) {
        func(...params);
    }
};

export const enum ACCEPTABLE_KEYS_PRESSED {
    ENTER = 'Enter',
    SPACEBAR = ' '
}
